import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';

import { firstValueFrom, tap } from 'rxjs';

import { OnAppInit } from '../bootstrap/bootstrapper.service';
import { WindowEvent } from '../browser/window/window-ref.service';
import { WINDOW } from '../browser/window/window.token';
import { Logger } from '../logging/logger';
import { UserService } from '../user/user.service';
import { DeviceFingerprintService } from './device-fingerprint.service';
import { RememberMeLoginService } from './remember-me-login.service';
import { RememberMeConfig } from './remember-me.client-config';
import { RememberMeService } from './remember-me.service';

@Injectable()
export class RememberMeBootstrapService implements OnAppInit {
    readonly #window = inject(WINDOW);
    private readonly isServer = isPlatformServer(inject(PLATFORM_ID));
    private readonly user = inject(UserService);
    private readonly rememberMeService = inject(RememberMeService);
    private readonly rememberMeLoginService = inject(RememberMeLoginService);
    private readonly rememberMeConfig = inject(RememberMeConfig);
    private readonly deviceFingerprintService = inject(DeviceFingerprintService);
    private readonly log = inject(Logger);

    async onAppInit() {
        // TODO Improve handling this exception
        // RememberMeBootstrap service is not yet implemented on the server
        if (this.isServer) {
            return;
        }

        this.deviceFingerprintService.storeDeviceDetails({});

        if (this.rememberMeConfig.loginOnDocumentRequest) {
            this.#window.addEventListener(WindowEvent.BeforeUnload, () => this.rememberMeLoginService.setLastCallTimestamp(), false);
        }

        if (this.user.isAuthenticated || !this.rememberMeService.tokenExists()) {
            return;
        }

        if (!this.rememberMeConfig.loginOnDocumentRequest) {
            // Reload the page if vnauth cookie exists or a previous remember-me operation was too recent before the page load.
            if (this.rememberMeService.authTokenExists() || this.rememberMeLoginService.lastCallTooRecent()) {
                this.#window.location.reload();
                return;
            }

            try {
                await firstValueFrom(
                    this.rememberMeLoginService.loginWithToken().pipe(
                        tap((executed) => {
                            if (executed) this.log.infoRemote('RememberMe: Login with token on app init was successful.');
                        }),
                    ),
                );
            } catch (error) {
                this.log.errorRemote('RememberMe: Failed to login with token on app start. User is left unauthenticated.', error);
            }
        }
    }
}
